module.exports = __webpack_public_path__ + "static/media/silva-lose.baa9a02d.png";